// extracted by mini-css-extract-plugin
export default {"viewer":"PdfViewer_viewer__UghK0","fullHeight":"PdfViewer_fullHeight__zwWRW"};